import { LmIconFilledInternetCodeCube, LmIconOutlineInternetCodeCube } from '@mes-ui/lemma/icons';
import { WidgetIconProps } from 'icons/widgets/types';

const IconStudyPracticeCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineInternetCodeCube {...rest} /> : <LmIconFilledInternetCodeCube {...rest} />;

export default IconStudyPracticeCommon;
